const styles = {
  container: '',

  figure:
    'relative w-full aspect-square bg-gray-100 rounded-lg overflow-hidden group cursor-pointer',
  image: 'object-cover group-hover:scale-105 duration-200',
};

export default styles;
